import { types } from 'mobx-state-tree';

export default types
  .model('LoginSignupDialog', {
    requestInProgress: false,
    wasSuccessful: false,
    wasSubmitted: false,
    error: types.maybeNull(types.string),
  })
  .views(self => ({
    get hasError() {
      return !!self.error;
    },
  }))
  .actions(self => ({
    setIsRequesting(state = true) {
      self.requestInProgress = state;
      return self;
    },
    setError(message) {
      self.error = message;
      return self;
    },
    clearError() {
      self.error = null;
      return self;
    },
    setWasSuccessful(wasSuccessful = true) {
      self.wasSuccessful = wasSuccessful;
      return self;
    },
    setWasSubmitted(wasSubmitted = true) {
      self.wasSubmitted = wasSubmitted;
      return self;
    },
  }));
